export const ChatTopEnum = {
  TOP: 1, // 置顶
  NOT_TOP: 0, // 不是置顶
};

export const ChatType = {
  ALL: 1, //全部
  NEW: 2, //新消息
  UNANSWERED: 3, //未回复
  KEY_CUSTOMERS: 4, // 重要老客
  PAID_CHATROOM: 5, //付费咨询室
  CARD_CLIENT: 6, //牌阵客户
  HISTORY_CHATROOM: 8, //历史咨询室
  COFFEE: 9, //咖啡厅客户
  FOLLOW_UP: 11, //平台助理-回访
  TODAY_USER: 13, // 今日用户
};

export const ChatStatus = {
  1: 'all',
  2: 'new',
  3: 'unanswered',
  4: 'key_customers',
  5: 'paid_chatroom',
  6: 'card_client',
  8: 'history_chatroom',
  9: 'coffee',
  11: 'follow_up',
  12: 'follow_up_daily',
  13: 'today_user',
};

export const RETURN_VISIT = 999; // 每日回访

export const ProvideKey = {
  ROOM_INFO: Symbol(),
};
